module.exports = __webpack_public_path__ + "static/media/golfer-5-a.86267c28.png";